
import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { AuditHistoryService } from "../services/audit-history-service";
import { EntityService } from "../services/entity-service";
import { NotifyService } from "../services/notify-service";
import { EventService } from "../services/event-service";
import { DateLocaleService } from "../services/date-locale-service";

import * as moment from "moment";

export interface IAuditHistoryScope extends ng.IScope {
    entityId: string;
}

export function RLAuditHistory(): ng.IDirective {
    return {
        restrict: 'EA',
        template: require("/assets/app/templates/audit-history.html"),
        scope: {
            entityId: "@"
        },
        controller: AuditHistoryController,
        bindToController: true,
        controllerAs: 'ahVM',
        link: (scope: IAuditHistoryScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any) => {
        }
    }
}

export class AuditHistoryController {
    static $inject = ["$window", "$scope", "$q", "auditHistoryService", "entityService", "notifyService", "eventService", "dateLocaleService"];

    entityId: string;

    //Filtering
    validCharTypes: Models.IAuditHistoryCharType[] = [];
    expandedRow: boolean[] = [];
    entityTemplateID: number;
    amendments: { item1: number, item2: Date }[] = [];
    amendment: { item1: number, item2: Date };
    expandedCharType: { [charTypeID: number]: boolean } = {};
    expandedGroup: { [groupID: number]: boolean } = {};
    showAmendments: boolean = false;
    filterValue: string;
    auditFilter: Models.IAuditHistoryFilter = {
        charTypes: [{ charTypeID: -1, charTypeName: 'Workflow', groups: [] }],
        emails: '',
        startDate: '',
        endDate: '',
        page: 1,
        rows: 0,
        inUTC: true,
        lastAmendment: false
    }
    selectAll: boolean = false;
    entityCreateDate: string;
    selectedCharTypes: number[] = [];
    selectedGroups: Models.IAuditHistoryCharTypeGroup[] = [];
    selectedCharacteristics: Models.IAuditHistoryCharTypeGroupField[] = [];
    //--

    //Paging
    pageCount: number = 0;
    numFound: number = 0;
    //--

    loading: boolean = false;
    detailsLoading: boolean = false;

    auditRows: Models.IAuditHistory[] = [];
    auditDetailRows: Models.IAuditHistoryDetail[] = [];

    startDate: string;
    endDate: string;

    amendmentStartDate: string;
    amendmentEndDate: string;

    filter: string = "byDate";

    constructor(
        private $window: ng.IWindowService,
        private $scope: ng.IScope,
        private $q: ng.IQService,
        private auditHistoryService: AuditHistoryService,
        private entityService: EntityService,
        private notifyService: NotifyService,
        private eventService: EventService,
        private dateLocaleService: DateLocaleService) {

        $scope.$watch(() => this.entityId, (newValue, oldValue) => {
            if (newValue) {
                this.Init();
            }
        });

        $scope.$watch(() => this.expandedRow, (newValue, oldValue) => {
            this.auditDetailRows = [];

            if (newValue != oldValue && newValue.length > 0 && _.filter(newValue, n => n == true).length == 1) {
                this.GetAuditHistoryDetail();
            }
        }, true);

        this.$scope.$watch(() => {
            if (this.entityId == null) {
                return null;
            } else {
                return this.entityId;
            }
        },
            (newValue, oldValue) => {
                if (newValue != null) {
                    this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
                        //Refresh the Amendments drop down
                        var amendmentPromise = this.GetEntityAmendments();
                        this.amendment = null;

                        //Get the default history, which is Workflow
                        var historyPromise = this.GetAuditHistory();

                        return this.$q.all([amendmentPromise, historyPromise]);
                    });
                }
            });
    }

    Init() {
        this.GetEntity()
            .then(() => {
                this.selectedCharTypes.push(-1);
                this.GetValidCharTypes();
                this.GetAuditHistory();
            })
    }

    ApplyFilters() {
        this.auditFilter.page = 1;
        this.GetAuditHistory();
    }

    GetEntity(): ng.IPromise<any> {
        this.notifyService.startProgress();
        return this.entityService.getEntityRecord(this.entityId)
            .then((result) => {
                if (result.recordRevisionID > 0) {
                    this.GetEntityAmendments();
                }

                //Get the entity's templateID
                this.entityTemplateID = result.templateID;

                //Set the default dates
                this.entityCreateDate = result.created;
                this.GetDefaultFilterDates();

                //Set the default rows
                this.auditFilter.rows = 10;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    //Get the audit history data based on the desired filters.  The default will be workflow history
    GetAuditHistory() {
        this.notifyService.startProgress();
        this.auditFilter.inUTC = true;
        this.loading = true;

        this.ResetAuditHistory();
        if (!this.amendment && this.filter !== "byDate") {
            this.loading = false;
            this.notifyService.endProgress();
            return true;
        } else {
            var startDateMoment = this.filter === "byDate"
                ? this.dateLocaleService.parseMoment(this.startDate)
                : moment(this.amendmentStartDate);
            var endDateMoment = this.filter === "byDate"
                ? this.dateLocaleService.parseMoment(this.endDate)
                : moment(this.amendmentEndDate);
            if (this.filter === "byDate") {
                this.auditFilter.inUTC = false;
                endDateMoment = endDateMoment.set({ 'hour': 23, 'minute': 59, 'second': 59, 'millisecond': 99 });
            }
            var usStartDate = this.dateLocaleService.delocalizeMoment(startDateMoment).format('YYYY-MM-DDTHH:mm:ss.SSSz');
            var usEndDate = this.dateLocaleService.delocalizeMoment(endDateMoment).format('YYYY-MM-DDTHH:mm:ss.SSSz');
            this.auditFilter.startDate = usStartDate;
            this.auditFilter.endDate = usEndDate;

            return this.auditHistoryService.getEntityAuditHistory(this.entityId, this.auditFilter)
                .then((results) => {
                    results.data.forEach(r => {
                        //Turn all times local
                        r.localAuditDate = moment.utc(r.auditDate).local().format();
                    });

                    this.auditRows = results.data;

                    //Get the total count, which is just a column in the results
                    if (results.data && results.data.length > 0) {
                        this.numFound = _.first(results.data).totalCount;
                    } else {
                        this.numFound = 0;
                    }
                })
                .finally(() => {
                    this.loading = false;
                    this.notifyService.endProgress();
                });
        }
    }

    //Get the detail for an audit history header entry
    GetAuditHistoryDetail() {
        this.notifyService.startProgress();
        this.detailsLoading = true;

        var row = this.auditRows[this.expandedRow.indexOf(true)]
        return this.auditHistoryService.getEntityAuditHistoryDetail(this.auditFilter.charTypes, row.isHeader, row.logIndicator, row.sequenceValue, row.operationID, row.templateID)
            .then((results) => {
                var detailData = results.data;
                for (let data of detailData) {
                    for (let field of data.fields) {
                        //check to make sure that the field is an actual date and not just a number value
                        if (moment(field.oldValue).isValid() && field.oldValue.indexOf("/") >= 0) {
                            field.oldValue  = moment(field.oldValue).format("L");
                        }
                        if (moment(field.newValue).isValid() && field.newValue.indexOf("/") >= 0) {
                            field.newValue = moment(field.newValue).format("L");
                        }
                    }
                }
                this.auditDetailRows = detailData;
            })
            .finally(() => {
                this.detailsLoading = false;
                this.notifyService.endProgress();
            });
    }

    //Get the chartypes that are valid based on the user's ACLs
    GetValidCharTypes() {
        this.notifyService.startProgress();
        this.auditHistoryService.getAllowedCharTypes(this.entityId, this.entityTemplateID)
            .then((results) => {
                this.validCharTypes = results.data;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    GetEntityAmendments() {
        return this.auditHistoryService.getEntityAmendments(this.entityId)
            .then((results) => {
                if (results.data && results.data.length > 0) {
                    this.showAmendments = true;
                    results.data.unshift(({ item1: 0, item2: this.entityCreateDate }) as any);
                    this.amendments = results.data;
                }
            });
    }

    //Construct the header text that differs based on the Operation type, whether the row is Module or Component level, and if it's a header level change or not
    CreateHeaderText(row: Models.IAuditHistory) {
        var friendlyString = row.operationLabel + " ";
        var charTypeName = row.charTypeName.toUpperCase();


        switch (row.operationID) {
            case Consts.AuditHistory.Operation.Added:
                if (Utils.CharUtil.IsModuleLevelCharType(row.charTypeID)) {
                    //Module
                    if (row.isParent == 1) {
                        friendlyString += row.changedField + " (" + charTypeName + ")";
                    }
                    else {
                        friendlyString += row.changedField + " (" + charTypeName + ": " + row.title + ")";
                    }

                }
                else {
                    //Component
                    if (row.isHeader == 1) {
                        friendlyString += row.title + " (" + charTypeName + ": " + row.templateName + ")";
                    }
                    else {
                        friendlyString += row.changedField + " (" + charTypeName + ": " + row.templateName + ": " + row.title + ")";
                    }
                }
                break;
            case Consts.AuditHistory.Operation.Changed:
                if (Utils.CharUtil.IsModuleLevelCharType(row.charTypeID)) {
                    //Module
                    friendlyString += row.changedField + " (" + charTypeName + ": " + row.title + ")";
                }
                else {
                    //Component
                    friendlyString += row.changedField + " (" + charTypeName + ": " + row.templateName + ": " + row.title + ")";
                }
                break;
            case Consts.AuditHistory.Operation.Deleted:
				if (Utils.CharUtil.IsModuleLevelCharType(row.charTypeID)) {
					//Module
					friendlyString += row.changedField + " (" + charTypeName + ": " + row.title + ")";
				}
				//When a value is removed from a rightset
				//if row.changedField == null, entire rightset got deleted so no need for specific message for field change
				else if (row.charTypeID == Consts.CharTypeIDs.right && row.changedField != null) {
					friendlyString += row.changedField + " (" + charTypeName + ": " + row.templateName + ": " + row.title + ")";
				}
                else {
                    //Component
                    friendlyString += row.title + " (" + charTypeName + ": " + row.templateName + ")";
                }
                break;
        }

        return friendlyString;
    }

    ResetAuditHistory() {
        this.pageCount = 1;
        this.numFound = 0;
        this.auditRows = [];
        this.auditDetailRows = [];
        this.expandedRow = [];
    }

    SelectAmendment() {
        if (this.amendment != null) {
            var amendmentsCount = this.amendments.length - 1;

            //startDate is when the amendment was created or entity was created in case of first amendment (Amendment 0)
            this.amendmentStartDate = moment(this.amendment.item2, 'YYYY-MM-DDTHH:mm:ss.SSSz').format('MM DD YYYY, HH:mm:ss.SSSz');

            //endDate should be when next amendment was created or the current date is there are no following amendments.
            if (this.amendment.item1 === amendmentsCount) {
                this.amendmentEndDate = moment.utc().format('MM DD YYYY, HH:mm:ss.SSS');
            } else {
                //Use next amendment date
                this.amendmentEndDate = moment(_.first(_.select(this.amendments, a => a.item1 == this.amendment.item1 + 1)).item2, 'YYYY-MM-DDTHH:mm:ss.SSSz').format('MM DD YYYY, HH:mm:ss.SSSz');
            }
        }
    }

    //Helpers
    ToggleFilterPanel() {
        this.$scope.$broadcast(Consts.Events.RLDropPanelClose);
    }

    ClearAllFilters() {
        this.selectAll = false;
        this.expandedCharType = {};
        this.expandedGroup = {};
        this.selectedCharTypes = [];
        this.selectedCharTypes.push(-1);
        this.selectedGroups = [];
        this.selectedCharacteristics = [];
        this.amendment = null;
        this.filter = "byDate";

        this.auditFilter = {
            charTypes: [{ charTypeID: -1, charTypeName: 'Workflow', groups: [] }],
            emails: '',
            startDate: '',
            endDate: '',
            page: 1,
            rows: 10,
            inUTC: true,
            lastAmendment: false
        }
        this.GetDefaultFilterDates();
        this.GetAuditHistory();
    }

    ToggleCheckAll() {
        this.auditFilter.charTypes = [];
        this.selectedCharTypes = [];
        this.selectedGroups = [];
        this.selectedCharacteristics = [];

        if (this.selectAll) {
            this.validCharTypes.forEach(c => {
                this.auditFilter.charTypes.push(_.cloneDeep(c));

                this.selectedCharTypes.push(c.charTypeID);

                //Select all the groups
                this.selectedGroups.push.apply(this.selectedGroups, c.groups);

                //Select all the chars
                c.groups.forEach(g => {
                    this.selectedCharacteristics.push.apply(this.selectedCharacteristics, g.characteristics);
                });
            });
        }
    }

    //TODO: Change the UI to the rl-tree-list-2 directive to avoid all the checkbox/selection shenanigans seen below
    ToggleCharTypeView(charTypeID: number) {
        this.expandedCharType[charTypeID] = !this.expandedCharType[charTypeID];
    }

    ToggleCharType(charType: Models.IAuditHistoryCharType) {
        if (_.filter(this.auditFilter.charTypes, c => c.charTypeID == charType.charTypeID).length == 1) {
            var filteredCharType = _.filter(this.auditFilter.charTypes, c => c.charTypeID == charType.charTypeID)[0];

            //Remove the charType
            var filteredCharTypeIndex = _.indexOf(this.auditFilter.charTypes, filteredCharType);
            this.auditFilter.charTypes.splice(filteredCharTypeIndex, 1);

            if (charType.groups.length > 0) {
                this.selectedGroups = [];
                this.selectedCharacteristics = [];
            }
        }
        else {
            //Add the charType
            this.auditFilter.charTypes.push(_.cloneDeep(charType));

            //Update the checkboxes
            this.selectedGroups.push.apply(this.selectedGroups, charType.groups);
            charType.groups.forEach(g => {
                this.selectedCharacteristics.push.apply(this.selectedCharacteristics, g.characteristics);
            })

        }
    }

    ToggleGroupView(groupID: number) {
        this.expandedGroup[groupID] = !this.expandedGroup[groupID];
    }

    ToggleGroup(charType: Models.IAuditHistoryCharType, group: Models.IAuditHistoryCharTypeGroup) {
        if (_.filter(this.auditFilter.charTypes, c => c.charTypeID == charType.charTypeID).length == 1) {
            var filteredCharType = _.filter(this.auditFilter.charTypes, c => c.charTypeID == charType.charTypeID)[0];

            if (_.filter(filteredCharType.groups, g => g.groupID == group.groupID).length == 1) {
                //Remove the group
                var filteredGroupIndex = _.indexOf(filteredCharType.groups, _.filter(filteredCharType.groups, g => g.groupID == group.groupID)[0]);
                if (filteredGroupIndex >= 0) { filteredCharType.groups.splice(filteredGroupIndex, 1); }

                //Remove its characteristics
                _.forEach(group.characteristics, c => {
                    var selectedCharacteristicIndex = _.indexOf(this.selectedCharacteristics, c);
                    this.selectedCharacteristics.splice(selectedCharacteristicIndex, 1);
                });

                //Are there any more groups in the charType? If not, remove the charType
                if (filteredCharType.groups.length == 0) {
                    var filteredCharTypeIndex = _.indexOf(this.auditFilter.charTypes, filteredCharType);
                    if (filteredCharTypeIndex >= 0) { this.auditFilter.charTypes.splice(filteredCharTypeIndex, 1); }
                    //Checkbox collection
                    var selectedCharTypeIndex = _.indexOf(this.selectedCharTypes, charType.charTypeID);
                    if (selectedCharTypeIndex >= 0) { this.selectedCharTypes.splice(selectedCharTypeIndex, 1); }
                }
            }
            else {
                //Add the group
                filteredCharType.groups.push({
                    groupID: group.groupID,
                    groupLabel: group.groupLabel,
                    characteristics: _.clone(group.characteristics)
                });

                //Add all its characteristics
                this.selectedCharacteristics.push.apply(this.selectedCharacteristics, group.characteristics);
            }

            return;
        }

        //Add the charType and the group
        this.selectedCharTypes.push(charType.charTypeID);
        this.auditFilter.charTypes.push({
            charTypeID: charType.charTypeID, charTypeName: charType.charTypeName,
            groups: [_.cloneDeep(group)]
        });
        this.selectedGroups.push(group);

        //Add all its characteristics
        this.selectedCharacteristics.push.apply(this.selectedCharacteristics, group.characteristics);
    }

    ToggleCharacteristic(charType: Models.IAuditHistoryCharType, group: Models.IAuditHistoryCharTypeGroup, characteristic: Models.IAuditHistoryCharTypeGroupField) {
        if (_.filter(this.auditFilter.charTypes, c => c.charTypeID == charType.charTypeID).length == 1) {
            var filteredCharType = _.filter(this.auditFilter.charTypes, c => c.charTypeID == charType.charTypeID)[0];

            if (_.filter(filteredCharType.groups, g => g.groupID == group.groupID).length == 1) {
                var filteredGroup = _.filter(filteredCharType.groups, g => g.groupID == group.groupID)[0];

                if (_.filter(filteredGroup.characteristics, ch => ch.characteristicID == characteristic.characteristicID).length == 1) {
                    //Remove the characteristic
                    var filteredCharacteristicIndex = _.indexOf(filteredGroup.characteristics, _.filter(filteredGroup.characteristics, ch => ch.characteristicID == characteristic.characteristicID)[0]);
                    filteredGroup.characteristics.splice(filteredCharacteristicIndex, 1);

                    //Are there any more characteristics in the group? If not, remove the group
                    if (filteredGroup.characteristics.length == 0) {
                        //Remove the group
                        var filteredGroupIndex = _.indexOf(filteredCharType.groups, _.filter(filteredCharType.groups, g => g.groupID == group.groupID)[0]);
                        if (filteredGroupIndex >= 0) { filteredCharType.groups.splice(filteredGroupIndex, 1); }
                        //Checkbox collection
                        var filteredSelectedGroupIndex = _.indexOf(this.selectedGroups, group);
                        if (filteredSelectedGroupIndex >= 0) { this.selectedGroups.splice(filteredSelectedGroupIndex, 1); }

                        //Are there any more groups in the charType? If not, remove the charType
                        if (filteredCharType.groups.length == 0) {
                            var filteredCharTypeIndex = _.indexOf(this.auditFilter.charTypes, filteredCharType);
                            if (filteredCharTypeIndex >= 0) { this.auditFilter.charTypes.splice(filteredCharTypeIndex, 1); }
                            //Checkbox collection
                            var selectedCharTypeIndex = _.indexOf(this.selectedCharTypes, charType.charTypeID);
                            if (selectedCharTypeIndex >= 0) { this.selectedCharTypes.splice(selectedCharTypeIndex, 1); }
                        }
                    }
                }
                else {
                    //Add the characteristic
                    filteredGroup.characteristics.push(_.clone(characteristic));
                }
            }
            else {
                //Add the group
                var clonedGroup = _.clone(group);
                var clonedChar = _.clone(characteristic);

                clonedGroup.characteristics = [];
                clonedGroup.characteristics.push(clonedChar);

                filteredCharType.groups.push(clonedGroup);

                this.selectedGroups.push(group);
                this.selectedCharacteristics.push(characteristic);
            }

            return;
        }

        //Add the charType, group, and characteristic
        var clonedGroup = _.clone(group);
        var clonedChar = _.clone(characteristic);

        clonedGroup.characteristics = [];
        clonedGroup.characteristics.push(clonedChar);

        this.auditFilter.charTypes.push({
            charTypeID: charType.charTypeID, charTypeName: charType.charTypeName,
            groups: [clonedGroup]
        });

        //Add to the checkbox collections
        this.selectedCharTypes.push(charType.charTypeID);
        this.selectedGroups.push(group);
        this.selectedCharacteristics.push(characteristic);
    }

    PageSizeChanged(size: number) {
        this.auditFilter.rows = size;
        this.auditFilter.page = 1;
        this.GetAuditHistory();
    }

    PageChanged(page: number) {
        this.auditFilter.page = page;
        this.GetAuditHistory();
    }

    GetDefaultFilterDates() {
        //Always default to when the entity was created.  We used to do 3 months, but users requested the change
        this.startDate = moment(this.entityCreateDate).format("L");
        this.endDate = moment().startOf('day').add(1, "day").format("L");
    }
    //--
}